import b from 'b_';
import cx from 'classnames';
import { Text } from 'platform-components';
// @ts-ignore
import uiKitColors from 'platform-components/src/design/ui-kit-colors.scss';
import React from 'react';

import './circle-progress-bar.scss';
// @ts-ignore
import cssConstants from './constants.scss';

const PROGRESS_BAR_SIZE = Number((cssConstants.progressBarSize || '').replace('px', ''));
const PROGRESS_BAR_STROKE_WIDTH = Number((cssConstants.strokeWidth || '').replace('px', ''));
const SIZE_WITH_BORDERS = PROGRESS_BAR_SIZE + PROGRESS_BAR_STROKE_WIDTH * 2;
const START_ANGLE = 1.5;

interface Props {
    maxParts: number;
    mix?: string;
    passedParts: number;
}

class CircleProgressBar extends React.PureComponent<Props> {
    static defaultProps = {
        passedParts: 0,
    };

    canvas: HTMLCanvasElement;

    drawProgress = () => {
        const { maxParts, passedParts } = this.props;

        const context = this.canvas.getContext('2d');
        const center = SIZE_WITH_BORDERS / 2;
        // радиус считается от центра окружности до середины дуги
        // дуга у нас толстая, поэтому надо учитывать и ее ширину
        const radius = center - PROGRESS_BAR_STROKE_WIDTH / 2;
        const partDone = (passedParts / maxParts) * 2;
        const startAngle = START_ANGLE * Math.PI;
        const endAngle = (START_ANGLE + partDone - 2) * Math.PI;

        if (context) {
            context.beginPath();
            context.arc(center, center, radius, startAngle, endAngle, false);
            context.lineWidth = PROGRESS_BAR_STROKE_WIDTH;
            context.lineCap = 'round';
            // прокинуть цвет через constants не получается
            context.strokeStyle = uiKitColors.blue500;

            context.stroke();
        }
    };

    setCanvasRef = (ref: HTMLCanvasElement) => {
        this.canvas = ref;

        if (ref !== null) {
            this.drawProgress();
        }
    };

    render() {
        const { mix, maxParts, passedParts } = this.props;

        if (maxParts < passedParts) {
            // eslint-disable-next-line no-console
            console.warn('Вы пытаетесь нарисовать прогресс бар, где пройдено больше 100%');
        }

        const allPartsPassed = maxParts === passedParts;

        return (
            <div className={cx('circle-progress-bar', mix)}>
                <div className={b('circle-progress-bar', 'background', { full: allPartsPassed })}>
                    {!allPartsPassed && (
                        <canvas
                            className="circle-progress-bar__progress"
                            height={SIZE_WITH_BORDERS}
                            ref={this.setCanvasRef}
                            width={SIZE_WITH_BORDERS}
                        />
                    )}
                </div>
                <div className="circle-progress-bar__inner-text">
                    <Text
                        id="circleProgressBar.text"
                        size={Text.SIZE.XL}
                        values={{ max: maxParts, passed: passedParts }}
                        weight={Text.WEIGHT.M}
                    />
                </div>
            </div>
        );
    }
}

export default CircleProgressBar;
